import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=0d994a51&scoped=true&lang=pug&"
import script from "./ProjectPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectPage.vue?vue&type=style&index=0&id=0d994a51&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d994a51",
  null
  
)

export default component.exports